"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetectionSubheader = exports.DetectionInputContainer = exports.FeedbackHeaderContainer = exports.DetectionTypeLabel = exports.DetectionList = exports.DetectionLink = exports.DetectionText = exports.ModelSerialWrapper = void 0;
const ui_react_1 = require("@streem/ui-react");
exports.ModelSerialWrapper = ui_react_1.styled.section(({ hasFootbar = false, theme }) => ({
    borderBottom: hasFootbar ? `1px solid ${theme.colors.grey10}` : '',
}));
exports.DetectionText = ui_react_1.styled.span(({ theme }) => `
    display: inline-block;
    align-self: center;
    justify-self: start;
    background: ${theme.colors.grey05};
    border-radius: 4px;
    color: rgba(44, 44, 44, 0.73);
    padding: 4px 6px;
    text-decoration: none;
    font-weight: 600;
`);
exports.DetectionLink = ui_react_1.styled.a(({ theme }) => `
    display: inline-block;
    align-self: center;
    justify-self: start;
    background: ${theme.colors.grey05};
    border-radius: 4px;
    color: ${theme.colors.azure};
    padding: 4px 6px;
    font-weight: 600;
    text-decoration: none;
    :hover {
        background: ${theme.colors.grey10};
    }
`);
exports.DetectionList = ui_react_1.styled.div({
    display: 'grid',
    gridTemplateColumns: '130px auto',
    gridAutoRows: '32px',
    gridRowGap: '8px',
    height: '100%',
    maxHeight: '255px',
    overflow: 'auto',
    '::-webkit-scrollbar': {
        WebkitAppearance: 'none',
        width: '7px',
    },
    '::-webkit-scrollbar-thumb': {
        borderRadius: '4px',
        backgroundColor: 'rgba(0, 0, 0, .5)',
        boxShadow: '0 0 1px rgba(255, 255, 255, .5)',
    },
    borderBottom: `6px solid #fff`,
    borderTop: `6px solid #fff`,
});
exports.DetectionTypeLabel = ui_react_1.styled.span({
    display: 'inline-block',
    width: '130px',
    alignSelf: 'center',
    justifySelf: 'start',
});
exports.FeedbackHeaderContainer = ui_react_1.styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
});
exports.DetectionInputContainer = ui_react_1.styled.div({
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
});
exports.DetectionSubheader = (0, ui_react_1.styled)(ui_react_1.Subheader) `
    margin-bottom: 8px;
    line-height: 25px;
`;
//# sourceMappingURL=model_serial_list_styles.js.map